import { get } from './methods';

interface ResultadoParcialItemPauta {
  abstencao: boolean;
  descricao: string;
  idItemPauta: number;
  percentual: number;
  votos: number;
}

export interface ResultadoParcialResponse {
  itens: Array<ResultadoParcialItemPauta>;
  descricao: string | null;
  titulo: string;
}

const pauta = {
  resultadoParcialAGO: (idPauta: number) => {
    return get<ResultadoParcialResponse>(`pauta/${idPauta}/resultado-parcial`);
  },
};

export default pauta;
